@if (currentSection(); as currentSection) {
    <div class="wrapper">
        <ui-loader [inline]="true" />
        @if (currentSection.text) {
            @if (isNewUI()) {
                <ui-label
                    size="xs"
                    color="secondary">
                    {{ currentSection.text }}</ui-label
                >
            } @else {
                <span> {{ currentSection.text }}</span>
            }
        }
    </div>
}
